import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomeV1 from './v1/HomeV1';
import HomeV2 from './v2/HomeV2';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeV1 />} />
        <Route path="/v2" element={<HomeV2 />} />
      </Routes>
    </Router>
  );
}

export default App;
